export const defaultTextDictionary = {
    headerText: 'Layout Manager',
    title: 'Layouts',
    saveCurrentTitle: 'Save current widget configuration',
    saveCurrentPlaceholder: 'Enter configuration name',
};

export type LayoutManagerTextDictionaryKey = keyof typeof defaultTextDictionary;

export type LayoutManagerTextDictionary = Record<
    LayoutManagerTextDictionaryKey,
    string
>;

export const defaultDictionaryByLayoutName = {
    loadLayout: (name: string) => `Make ${name} active`,
};

export type LayoutManagerByLayoutNameDictionaryKey =
    keyof typeof defaultDictionaryByLayoutName;

export type LayoutManagerByLayoutNameDictionary = Record<
    LayoutManagerByLayoutNameDictionaryKey,
    (layoutName: string) => string
>;

export type LayoutManagerDictionary = LayoutManagerTextDictionary &
    LayoutManagerByLayoutNameDictionary;

export const defaultDictionary: LayoutManagerDictionary = {
    ...defaultTextDictionary,
    ...defaultDictionaryByLayoutName,
};
